import {Rfc} from "../../models/request";
import {Component} from '@angular/core';
import {
    AlertController, LoadingController, NavController, NavParams,
    ToastController
} from "ionic-angular";
import {View} from "./contract";
import {BasePresenter} from "./presenter";


@Component({
    selector: 'base',
    template: '',
})
export class BaseRfcPage implements View
{
    
    protected RFC_NAV_PARAM = "rfc";
    protected rfc: Rfc;
    
    
    // Common UI
    protected label: string = "Amount (excl. GST)";
    protected value: any = "";
    protected bannerText: string = "";
    protected notes: string = "";
    private loader: any;
    protected loadingMessage = "Loading";
    protected toastDuration: number = 3000;
    errorAlert: any;
    
    
    constructor(private loadingCtrl: LoadingController,
        private alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public presenter: BasePresenter,
        private navController: NavController,
        public navParams: NavParams)
    {
        presenter.setView(this);
    }
    
    ngOnInit()
    {
        console.log("base class init");
        this.rfc = this.navParams.get(this.RFC_NAV_PARAM);
        
        if (this.rfc)
        {
            this.value = this.rfc.rfcAmount;
        }
        else
        {
            // this.navController.
        }
        
    }
    
    /**
     * Shows a loader with the default loading message
     */
    showLoader()
    {
        this.loader = this.loadingCtrl.create({
            content: this.loadingMessage
        });
        
        this.loader.present();
    }
    
    /**
     * Hides the loader
     * @returns {boolean}
     */
    hideLoader()
    {
        if (this.loader)
        {
            return this.loader.dismiss();
        }
        else
        {
            return false;
        }
    }
    
    showError(title: string, message: string): void
    {
        this.errorAlert = this.alertCtrl.create({
            title: title,
            message: message,
            buttons: ["Ok"]
        });
        this.errorAlert.present();
    }
    
    hideError(): void
    {
        this.errorAlert.dismiss();
    }
    
    
    navigate(route: string): void
    {
        // this.navController.popAll().then(res =>
        // {
        this.navController.setRoot(route);
        // });
    }
    
    /**
     * Shows a toast message
     * @param {string} message
     */
    showMessage(message: string): void
    {
        let toast = this.toastCtrl.create({
            message: message,
            duration: this.toastDuration,
            closeButtonText: "Ok",
            dismissOnPageChange: false
        });
        
        toast.present();
    }
    
    /**
     * Hide the toast
     */
    hideMessage(): void
    {
    }
    
    /**
     * Must override in child instances
     */
    update()
    {
    }
    
}


// WEBPACK FOOTER //
// ./src/pages/base/baseRfcPage.ts